import { Provider as BaseProvider } from 'react-contextual'
import baseSubscribe from 'lib/context'
import store from './store'

// This is the context provider/subscribe function for our primary app store
// The app store is used for login information, user state, etc.
// wrapper utility for creating context providers
export const Provider = (props) => <BaseProvider store={store} {...props} />
export default (map) => baseSubscribe(map, store)
